export default function (topMenuOptions, currentUser, userInRole, $compile) {
    return {
        link: (scope, element) => {
            currentUser()
                 .then(result => {
                     let optionElements = '';
                     const menuOptions = [];

                     for (let count = 0; count < topMenuOptions.items.length; count++) {
                         const option = topMenuOptions.items[count];
                         if (userInRole.verify(result.roles, option.roles)) {
                             menuOptions.push(option);
                         }
                     }

                     for (let count = 0; count < menuOptions.length; count++) {
                         const option = menuOptions[count];
                         const inputElement = `<input highlight-when-child-of="${option.highlightWhenChildOf}" ui-sref-opts="{inherit: false}" ui-sref="${option.uiSref}" type="radio" name="nav-tabs" id="nav-tab${count + 1}">`;
                         const spanElement = `<span class="nav-button"><label for="nav-tab${count + 1}">${option.text}</label></span>`;
                         optionElements += `${inputElement}${spanElement}`;
                     }

                     const menuTemplate = `<div class="nav-container"><div class="nav-buttons">${optionElements}</div></div>`;

                     element.html(menuTemplate);

                     $compile(element.contents())(scope);
                 });
        }
    };
}



// WEBPACK FOOTER //
// ./Client/app/common/directives/topMenu.js